import {
  currentLegalDocuments,
  legalDocumentsByVersion,
  type LegalDocumentKind,
  type LegalDocumentVersion,
  type LegalSectionBlock
} from "./legalDocuments.js";

function LegalDataTable({ rows, hasHeader = false }: { rows: string[][]; hasHeader?: boolean }) {
  return (
    <div className="legal-table-scroll" tabIndex={0} role="region" aria-label="文档表格">
      <table className="legal-table">
        {hasHeader ? (
          <>
            <thead>
              <tr>{rows[0].map((cell, cellIndex) => <th key={cellIndex} scope="col">{cell}</th>)}</tr>
            </thead>
            <tbody>
              {rows.slice(1).map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => cellIndex === 0
                    ? <th key={cellIndex} scope="row">{cell}</th>
                    : <td key={cellIndex}>{cell}</td>)}
                </tr>
              ))}
            </tbody>
          </>
        ) : (
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <th scope="row">{row[0]}</th>
                <td>{row[1]}</td>
              </tr>
            ))}
          </tbody>
        )}
      </table>
    </div>
  );
}

function LegalBlock({ block }: { block: LegalSectionBlock }) {
  if (block.type === "paragraph") return <p>{block.text}</p>;
  if (block.type === "list") {
    return <ul>{block.items.map((item) => <li key={item}>{item}</li>)}</ul>;
  }
  return <LegalDataTable rows={block.rows} hasHeader />;
}

export function LegalPage({ kind, version }: { kind: LegalDocumentKind; version?: LegalDocumentVersion }) {
  const document = version ? legalDocumentsByVersion[version][kind] : currentLegalDocuments[kind];
  const titleId = `legal-${kind}-title`;

  return (
    <main className="legal-page" aria-labelledby={titleId}>
      <article className="legal-document">
        <header className="legal-document-header">
          <h1 id={titleId}>{document.title}</h1>
          <p className="legal-document-subtitle">{document.subtitle}</p>
        </header>

        <LegalDataTable rows={document.metadata} />
        {document.notice && <aside className="legal-document-notice">{document.notice}</aside>}

        <div className="legal-document-body">
          {document.sections.map((section) => (
            <section key={section.heading}>
              <h2>{section.heading}</h2>
              {section.blocks.map((block, index) => <LegalBlock key={`${section.heading}-${index}`} block={block} />)}
            </section>
          ))}
        </div>
      </article>
    </main>
  );
}
